export default __webpack_public_path__ + "static/media/times.d11d05a6.svg";